import RoundedButton, {ButtonType} from 'src/components/elements/RoundedButton';
import GrpReferralRedesign from 'src/components/img/svg/GrpReferralredesign';
import Styles from 'src/components/Styles';
import Localized from 'src/constants/AppStrings';

export function getReferralStyles(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    referralTitle: {
      marginTop: Styles.Spacing.m2,
      fontSize: Styles.Fonts.f3,
      fontWeight: 'bold',
      textAlign: 'center',
      fontFamily: Styles.FontFamily.robotoRegular,
      color: Styles.Colors.Canteen.darkGreen,
    },
    referralDesc: {
      marginTop: Styles.Spacing.m2 + Styles.Spacing.m1,
      fontSize: Styles.Fonts.f1,
      fontWeight: '400',
      textAlign: 'center',
      fontFamily: Styles.FontFamily.robotoRegular,
      color: Styles.tabBarTextColor,
    },
    referralExpiry: {
      marginTop: Styles.Spacing.m3,
      fontSize: Styles.Fonts.f1,
      fontWeight: '400',
      textAlign: 'center',
      fontFamily: Styles.FontFamily.robotoRegular,
      color: Styles.Colors.Canteen.darkGreen,
    },
    totalReferralsKey: {
      fontSize: Styles.Fonts.f8,
      fontWeight: '400',
      textAlign: 'center',
      fontFamily: Styles.FontFamily.robotoRegular,
      color: Styles.lightGray,
      height: 18,
    },
    totalReferralsValue: {
      fontSize: Styles.Fonts.f3,
      fontWeight: 'bold',
      textAlign: 'left',
      fontFamily: Styles.FontFamily.robotoRegular,
      color: Styles.tabBarTextColor,
    },
    shareViaEmailTitle: {
      fontSize: Styles.Fonts.f7,
      fontWeight: '400',
      textAlign: 'left',
      fontFamily: Styles.FontFamily.robotoRegular,
      color: Styles.tabBarTextColor,
    },
    errorLabel: {
      color: Styles.dangerColor,
      fontSize: Styles.Fonts.f8,
      alignSelf: 'flex-start',
      fontFamily: Styles.FontFamily.robotoRegular,
      marginHorizontal: Styles.Spacing.m3,
      marginTop: Styles.Spacing.m1,
    },
    orText: {
      fontSize: Styles.Fonts.f1,
      textTransform: 'uppercase',
      color: Styles.tabBarTextColor,
      fontFamily: Styles.FontFamily.robotoRegular,
      marginHorizontal: Styles.Spacing.m3,
    },
  };
}

export function getReferralTitleMsg(amount: string): string {
  return Localized.Labels.formatString(
    Localized.Labels.referral_invite_earn_desc,
    'Connect & Pay',
    amount,
    amount,
  ).toString();
}

export function getReferralHeaderIcon() {
  return (
    <GrpReferralRedesign
      width={78}
      height={74}
      gradColor1={Styles.Colors.Canteen.darkGreen}
      gradColor2="#b9c3ca"
    />
  );
}

export function getSendInviteButton(
  checkDisabled: () => boolean,
  callback: () => void,
) {
  return (
    <RoundedButton
      buttonType={ButtonType.action}
      onPress={callback}
      disabled={checkDisabled()}
      accessibilityLabel="Send Invite"
      text={Localized.Buttons.send_invite}
      maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
    />
  );
}

export default {
  getReferralStyles,
  getReferralTitleMsg,
  getReferralHeaderIcon,
  getSendInviteButton,
};
